
import { useContext } from 'react'
import InputField, { InputFieldSimple } from '../InputField'
import { yesNoOptions } from '../../../../select/StaticSelectObjects'
import ReportSelect from '../../../../select/ReportSelect'
import { useFormContext } from 'react-hook-form'
import { ReportingContext } from '../../../../../wrappers/ReportingContext'

const SelectCommandOptions = () => {
    const { viewOnly, reportConfig } = useContext(ReportingContext)
    const { register, control, } = useFormContext()

    const limitProps = {
        name: "limit",
        className: "input",
        type: "number",
        min: "1",
        disabled: viewOnly,
        onInvalid: (e) => {
           e.preventDefault();
            e.target.setCustomValidity('Must be a positive integer');
        },
        onInput: (e) => e.target.setCustomValidity(''),
        ref: register({
            validate: {
                isPositiveInteger: (value) => {
                    if (!value || value === "") return true;
                    
                    const numValue = Number(value);
                    
                    if (!Number.isInteger(numValue) || numValue < 1) {
                        return "Must be a positive integer";
                    }
                    
                    return true;
                }
            }
        })
    }

    return (
        <div className="columns">
            {/* <div className='column is-1'></div> */}
            <div className='column is-5' style={{ marginLeft: '10px' }}>
                <InputFieldSimple 
                    label="Report Limit"
                    name="limit"
                    viewOnly={viewOnly}
                    inputProps={{...limitProps}}
                />
            </div>
            <div className='column is-6'>
                <InputField
                    label="Apply Distinct Clause?"
                    name="hasDistinct"
                >
                    <ReportSelect
                        name={"hasDistinct"}
                        control={control}
                        rules={{}}
                        options={yesNoOptions}
                        disabled={viewOnly}
                        value={reportConfig && reportConfig.hasDistinct ? true : false}
                        isClearable={false}
                    />
                </InputField>
            </div>
            <div className='column is-1'></div>
        </div>
    )
}

export default SelectCommandOptions